module.exports = __webpack_public_path__ + "img/voice_2.353fad54.svg";